export const LAYERED_MODAL_JS_CDN_URL = 'https://cdn.jsdelivr.net/npm/layered-modal@latest/dist/bundle.min.umd.js';

export const LAYERED_MODAL_CSS_CDN_URL = 'https://cdn.jsdelivr.net/npm/layered-modal@latest/dist/styles.min.css';

/** Full Font Awesome CSS (defer load in layout via DeferredGlobalStyles to avoid render-blocking). */
export const FONT_AWESOME_CSS_CDN_URL =
   'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css';

/** Reviews widget CSS is loaded only when the section enters viewport. */
export const REACT_GOOGLE_REVIEWS_CSS_CDN_URL =
   'https://cdn.jsdelivr.net/npm/react-google-reviews/dist/index.css';